import {gql} from '@apollo/client'
import React from 'react'
import {Button} from '../../components/library/buttons'
import {WebhookEndpointDetailFragment} from '../../data/workbench-api/generated/webhook-endpoint'
import {useToast} from '../../lib/toast'
import {useTestWebhookEndpointWithMappingOverrideMutation} from './generated/test'

interface TestWebhookButtonProps {
  webhookEndpoint: WebhookEndpointDetailFragment
  size?: 'xsmall' | 'small' | 'large'
  disabled?: boolean
  title?: string
  scriptMappingOverride?: string
}
export const TestWebhookButton = ({
  webhookEndpoint,
  size,
  disabled,
  title,
  scriptMappingOverride
}: TestWebhookButtonProps) => {
  const toaster = useToast()
  const [doMutation, {loading}] =
    useTestWebhookEndpointWithMappingOverrideMutation({
      onCompleted: () => {
        toaster('Webhook sent')
      }
    })

  return (
    <Button
      appearance="secondary"
      disabled={!!disabled || loading}
      onClick={() => {
        doMutation({
          variables: {
            environmentId: webhookEndpoint.environmentId,
            webhookEndpointId: webhookEndpoint.id,
            scriptMappingOverride
          }
        })
      }}
      title={title}
      style={{
        width: `calc(4.5em + ${size === 'large' ? '30px' : '20px'})`
      }}
      size={size}
    >
      Send test
    </Button>
  )
}

gql`
  mutation TestWebhookEndpointWithMappingOverride(
    $environmentId: String!
    $webhookEndpointId: String!
    $scriptMappingOverride: String
  ) {
    webhookEndpointTestMutation(
      environmentId: $environmentId
      endpointId: $webhookEndpointId
      scriptMappingOverride: $scriptMappingOverride
    )
  }
`
